import TagManager from "react-gtm-module-custom-domain";
import { ClaritySettings, ElasticSettings, GtmSettings, Settings } from "src/types/settings";

import clarity from "@microsoft/clarity";

import { getSettings } from "./configService";
import ElasticService from "./elasticService";

class AnalyticsSerive {
    private analytics: Settings["analytics"] = [];
    private initialized = false;

    public getClaritySettings(): ClaritySettings | null {
        const clarityAnalytic = this.analytics.find((analytic) => analytic.name === "clarity");
        // without that additional check, there are TypeScript errors
        if (clarityAnalytic && clarityAnalytic.name === "clarity") {
            return clarityAnalytic;
        }
        return null;
    }

    public getElasticSettings(): ElasticSettings | null {
        const elasticAnalytic = this.analytics.find((analytic) => analytic.name === "elastic");
        // without that additional check, there are TypeScript errors
        if (elasticAnalytic && elasticAnalytic.name === "elastic") {
            return elasticAnalytic;
        }
        return null;
    }

    public getGtmSettings(): GtmSettings | null {
        const gtmAnalytic = this.analytics.find((analytic) => analytic.name === "gtm");
        // without that additional check, there are TypeScript errors
        if (gtmAnalytic && gtmAnalytic.name === "gtm") {
            return gtmAnalytic;
        }
        return null;
    }

    private initializeClarity(): void {
        const clarityAnalytic = this.getClaritySettings();
        if (clarityAnalytic) {
            clarity.init(clarityAnalytic.id);
        }
    }

    private initializeElastic(): void {
        const elasticAnalytic = this.getElasticSettings();
        if (elasticAnalytic) {
            ElasticService.initApmContext();
            ElasticService.updateUserContext();
        }
    }

    private initializeGtm(): void {
        const gtmAnalytic = this.getGtmSettings();
        if (gtmAnalytic) {
            TagManager.initialize({
                gtmId: gtmAnalytic.id,
                customURL: gtmAnalytic.serverUrl,
            });
        }
    }

    public initialize(): void {
        // Guard against double-init under React StrictMode double-renders and Vite HMR — clarity
        // and GTM in particular re-inject their scripts on each call.
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        this.analytics = getSettings().analytics;
        this.initializeClarity();
        this.initializeElastic();
        this.initializeGtm();
    }
}
export default new AnalyticsSerive();
